import { FaqItem, GeneralLinkField, StringField } from '@models/graphQL';

export class FaqListResponse {
  title: StringField;
  link: GeneralLinkField;
  faqItems: FaqItem[];
}